import { gql } from "@apollo/client";
export default gql`
  mutation VerifyMfaToken($input: VerifyTokenInput!) {
    verifyMfaToken(input: $input) {
      accessToken
      message
    }
  }
`;
